// feature specific
export const ALL_HIGHLIGHTS_ID = '0';

// zindex
export const SIDEBAR_ZINDEX = 16;
export const HEADER_ZINDEX = 17;

// sizes
export const TOPBAR_HEIGHT = 56;
export const SECONDARY_TOPBAR_HEIGHT = 48;
export const SIDEBAR_WIDTH = 220;
export const SIDEBAR_COLLAPSED_WIDTH = 64;
